import styled from '@emotion/styled';
import { Form } from 'formik';

export const StyledLoginForm = styled(Form)`
  input[type='email'],
  input[type='password'] {
    background-color: transparent;
  }
`;

export const LoginFormFieldset = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;
  .animated-input-row {
    height: 52px;
    position: relative;
    .email-input-group,
    .phone-input-group {
      width: 100%;
      position: absolute;
      bottom: 0;
      transition: transform 0.4s cubic-bezier(0, 0.2, 0.2, 1.4),
        opacity 0.1s linear;
    }
    &.is-email {
      .email-input-group {
        transform: none;
        opacity: 1;
        pointer-events: inherit;
      }
      .phone-input-group {
        /* transform: perspective(600px) rotateX(180deg) translateY(-40px); */
        transform: scale(0.9) translateY(-40px);
        opacity: 0;
        pointer-events: none;
      }
    }
    &.is-phone {
      .email-input-group {
        /* transform: perspective(600px) rotateX(-180deg) translateY(-40px); */
        transform: scale(1.2) translateY(40px);
        opacity: 0;
        pointer-events: none;
      }
      .phone-input-group {
        transform: none;
        opacity: 1;
        transform: none;
        pointer-events: inherit;
      }
    }
  }
`;

export const LoginFormRow = styled.div`
  margin-bottom: 24px;
`;
